export default __webpack_public_path__ + "static/portfolio-cover-8-11e1f875b85b25f113c46dc855ff4574.jpg";